<!--version 0.9.08 — 2026-06-10T12:31:00-07:00 — officer view search: plain HTML input (no v-model) to eliminate keystroke re-render lag-->
<!--//@*/*
    //    *RPD Loiter Appv0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC . All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

<!-- confirm_city (city limits checkbox)
today_date
today_time
owner_name
contact_phone (with mask)
contact_email
existing_letter (drop down)
effective_date
property_type (drop down, required, start empty)
property_name
property_address (separate fields)
address line 1
Address line 2
City (reno default)
State(Nevada default)
zip

alt_contact_name1
alt_contact_phone1
alt_contact_name2
alt_contact_phone2
Authorizing Affirmation and Signature
auth_email (email required)
auth_agree (checkbox with I agree text)
owner_dl
activate_letter (drop down) -->
<template>
  <div class="home_vue_comp">
    <auth></auth>
    <v-main>
      <!-- dialog ********************** -->

      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="768">
            <v-card style="border: 1px solid white">
              <v-card-title>
                <span class="text-h5">Letter Data</span>
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="greenbtndrk black--text" @click="update_ltr()">
                  <v-icon>$save</v-icon>
                  Save
                </v-btn>
                <v-btn class="greenbtndrk black--text" @click="close_diag">
                  <v-icon>$close</v-icon>
                  Close
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-container>
                  <v-form
                    id="edit_form"
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                    <!-- row 1 -->
                    <v-row dense>
                      <v-col cols="12" md="12">
                        <v-btn
                          class="greenbtndrk black--text"
                          @click="addsign()"
                          >Update Sign Count</v-btn
                        >
                        <!-- <v-btn
                          class="greenbtndrk black--text remsign"
                          @click="remvsign"
                          >Subtract Sign Issued</v-btn
                        > -->
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="edit_ltr.phys_sign"
                          label="Phys. Sign Count"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          readonly
                          v-model="edit_ltr.last_date_phys_sign"
                          label="Last sign Date"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <!-- row 1 -->
                    <v-row dense>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Owner Name</label>
                        <v-text-field
                          :rules="nameRules"
                          class="mt-0 pt-0"
                          maxlength="120"
                          v-model="edit_ltr.owner_name"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Contact Email</label>
                        <v-text-field
                          :rules="emailRules"
                          maxlength="120"
                          v-model="edit_ltr.contact_email"
                          class="mt-0 pt-0"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- row 2 -->
                    <v-row dense>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Existing Letter</label>
                        <div class="select-wrapper">
                          <select
                            style="color: white; margin-top: 0"
                            v-model="edit_ltr.existing_letter"
                            id="existing_letter"
                          >
                            <option style="padding: 3px">
                              Renewal of an existing letter
                            </option>
                            <option style="padding: 3px">
                              New Authorization Letter
                            </option>
                          </select>
                        </div>
                        <!-- <v-select
                          id="existing_letter"
                          class="mt-0 pt-0"
                          v-model="edit_ltr.existing_letter"
                          :items="[
                            'Renewal of an existing letter',
                            'New Authorization Letter',
                          ]"
                          attach
                        > 
                        </v-select>-->
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Effective Date</label>
                        <v-text-field
                          dark
                          class="mt-0 pt-0 white--text"
                          type="date"
                          v-model="edit_ltr.effective_date"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- row 3 -->
                    <v-row dense>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Contact Phone</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          v-mask="'(###) ###-####'"
                          maxlength="14"
                          v-model="edit_ltr.contact_phone"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Property Type</label>
                        <div class="select-wrapper">
                          <select
                            style="color: white; margin-top: 0"
                            v-model="edit_ltr.property_type"
                            id="property_type"
                          >
                            <option
                              v-for="opt in property_types"
                              :key="opt"
                              style="padding: 3px"
                            >
                              {{ opt }}
                            </option>
                          </select>
                        </div>
                      </v-col>
                    </v-row>
                    <!-- row 4 -->
                    <v-row dense>
                      <v-col cols="12" md="12" class="d-flex flex-column">
                        <label>Property Name</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="14"
                          v-model="edit_ltr.property_name"
                          required
                        ></v-text-field>
                      </v-col>
                      <!-- <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Activate Letter</label>
                        <div class="select-wrapper">
                          <select
                            style="color: white; margin-top: 0"
                            v-model="edit_ltr.activate_letter"
                            id="activate_letter"
                          >
                            <option style="padding: 3px">YES</option>
                            <option style="padding: 3px">NO</option>
                          </select>
                        </div>
                      </v-col> -->
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" md="12">
                        <h4>Property Address</h4>
                      </v-col>
                    </v-row>
                    <!-- row 5 -->
                    <v-row dense>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Address Line 1</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="60"
                          v-model="edit_ltr.address_line1"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Address Line 2</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="60"
                          v-model="edit_ltr.address_line2"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- row 6 -->
                    <v-row dense>
                      <v-col cols="12" md="4" class="d-flex flex-column">
                        <label>City</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="60"
                          v-model="edit_ltr.city"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4" class="d-flex flex-column">
                        <label>State</label>
                        <div class="select-wrapper33">
                          <select
                            style="color: white; margin-top: 0"
                            v-model="edit_ltr.state"
                            id="state"
                          >
                            <option
                              v-for="opt in states"
                              :key="opt"
                              style="padding: 3px"
                            >
                              {{ opt }}
                            </option>
                          </select>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" class="d-flex flex-column">
                        <label>Zip</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="60"
                          v-model="edit_ltr.zip"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <hr class="mb-2" style="border-color: darkgray" />
                    <v-row dense class="mt-2">
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Alt Name1</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="120"
                          v-model="edit_ltr.alt_contact_name1"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Alt Phone1</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="120"
                          v-model="edit_ltr.alt_contact_phone1"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- row 7 -->
                    <v-row dense class="mt-2">
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Alt Name2</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="120"
                          v-model="edit_ltr.alt_contact_name2"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex flex-column">
                        <label>Alt Phone2</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="120"
                          v-model="edit_ltr.alt_contact_phone2"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- auth_email (email required)
auth_agree (checkbox with I agree text)
owner_dl
activate_letter (drop down) -->
                    <!-- row 8 -->
                    <v-row dense class="mt-2">
                      <v-col cols="12" md="12" class="d-flex flex-column">
                        <label>Owner DL</label>
                        <v-text-field
                          class="mt-0 pt-0"
                          dark
                          maxlength="120"
                          v-model="edit_ltr.owner_dl"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn class="greenbtndrk black--text" @click="update_ltr()">
                  <v-icon>$save</v-icon>
                  Save
                </v-btn>
                <v-btn class="greenbtndrk black--text" @click="close_diag">
                  <v-icon>$close</v-icon>
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <v-container class="homemain white--text pa-0" id="home-container">
        <!-- <v-btn class="orange black--text" @click="tgl_role">Toggle Role</v-btn> -->
        <!-- records_view -->
        <div
          id="records_view"
          class="appbck mview"
          v-if="isRecords == true"
          style="position: relative; top: 20px"
        >
          <h2 class="ml-2">Records View</h2>
          <h4 class="ml-3">Count: {{ lst_letters.length }} of {{ total_count }}</h4>
          <p class="ml-3 mb-0 appbck">
            Search (name, property, address, city): &nbsp;
          </p>
          <div class="ml-3 mr-3 d-flex flex-column flex-sm-row align-stretch align-sm-center">
            <v-text-field
              class="white-clear-icon pa-0"
              dark
              v-model="sterm"
              solo
              clearable
              hide-details
              @keyup.enter="submit_search"
              @click:clear="clear_search"
            ></v-text-field>
            <div class="d-flex mt-2 mt-sm-0 ml-sm-2">
              <v-btn
                class="black--text flex-grow-1"
                style="background-color: #138166"
                :disabled="!sterm"
                @click="submit_search"
              >
                Search
              </v-btn>
              <v-btn
                class="ml-2 black--text flex-grow-1"
                style="background-color: #c8a84b"
                :disabled="!sterm"
                @click="clear_search"
              >
                Clear
              </v-btn>
            </div>
          </div>
          <div class="ml-2 mt-3 mb-3 pa-0 d-flex tggl-cont">
            <p class="appbck">Sort: &nbsp;</p>

            <v-btn-toggle
              v-model="toggle_exclusive"
              mandatory
              active-class="ac_btn"
              @change="toggle_sort"
              class=""
            >
              <v-btn
                class="black--text"
                elevation="2"
                style="background-color: #138166"
              >
                A-Z
              </v-btn>
              <v-btn
                class="black--text"
                elevation="2"
                style="background-color: #138166"
              >
                Date
              </v-btn>
            </v-btn-toggle>
          </div>

          <v-card
            style="width: 95%; margin: auto"
            class="mb-5 cntct_card"
            v-for="ltr in lst_letters"
            :key="ltr.letterId"
            elevation="2"
            dark
            outline
            ><v-card-title v-if="ltr.property_name != ''">
              <span class="labeltext--text">Property Name:&nbsp;</span>
              {{ ltr.property_name }}
            </v-card-title>
            <v-card-title v-if="ltr.property_name == ''">
              <span class="labeltext--text">Owner Name:&nbsp;</span>
              {{ ltr.owner_name }}
            </v-card-title>
            <v-card-subtitle
              >{{ ltr.address_line1 }}&nbsp;
              <span v-if="ltr.address_line2">{{ ltr.address_line2 }} </span>
              <span class="labeltext--text">City:&nbsp;</span>
              {{ ltr.city }}
              <!-- ,<span class="labeltext--text">State:&nbsp;</span>
              {{ ltr.state }},
              <span class="labeltext--text">Zip:&nbsp;</span>
              {{ ltr.zip }} -->
            </v-card-subtitle>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="4">
                  <div class="d-flex">
                    <span class="labeltext--text">Phone:&nbsp;</span
                    >{{ ltr.contact_phone }}
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="d-flex">
                    <span class="labeltext--text">Email:&nbsp;</span
                    >{{ ltr.contact_email }}
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="d-flex">
                    <span class="labeltext--text"
                      >Effective&nbsp;Date:&nbsp;</span
                    >{{ ltr.effective_date }}
                  </div>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="d-flex">
                    <span class="labeltext--text">Sign Count:&nbsp;</span
                    >{{ ltr.phys_sign }}
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex">
                    <span class="labeltext--text">Last Sign Date:&nbsp;</span
                    >{{ ltr.last_date_phys_sign }}
                  </div>
                </v-col>
              </v-row>
              <v-card-actions>
                <!-- buttons -->
                <v-btn class="greenbtndrk black--text" @click="edit(ltr)">
                  <v-icon>$edit</v-icon>
                  Edit
                </v-btn>
                <v-btn
                  class="greenbtndrk black--text"
                  @click="delete_promp(ltr)"
                >
                  <v-icon>$del</v-icon>
                  Delete
                </v-btn>
              </v-card-actions>
              <v-expansion-panels dark class="mt-2">
                <v-expansion-panel>
                  <v-expansion-panel-header style="border: 1px solid white">
                    More Contacts
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Alt Name 1:&nbsp;</span
                          >{{ ltr.alt_contact_name1 }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Alt Phone 1:&nbsp;</span
                          >{{ ltr.alt_contact_phone1 }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Alt Name 2:&nbsp;</span
                          >{{ ltr.alt_contact_name2 }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Alt Phone 2:&nbsp;</span
                          >{{ ltr.alt_contact_phone2 }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense class="mt-2">
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Address:&nbsp;</span
                          >{{ ltr.address_line1 }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Suite:&nbsp;</span
                          >{{ ltr.address_line2 }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense class="">
                      <v-col cols="12" md="4">
                        <div class="d-flex">
                          <span class="labeltext--text">City:&nbsp;</span
                          >{{ ltr.city }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="d-flex">
                          <span class="labeltext--text">State:&nbsp;</span
                          >{{ ltr.state }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="d-flex">
                          <span class="labeltext--text">Zip:&nbsp;</span
                          >{{ ltr.zip }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
          <p v-if="show_no_contacts">No contacts match search.</p>
          <div class="d-flex flex-wrap align-center justify-center mt-4 mb-4">
            <div class="mr-4 mb-2">
              <span class="labeltext--text">Per page:&nbsp;</span>
              <v-btn-toggle
                :value="page_size_options.findIndex(o => o.value === page_size)"
                mandatory
                active-class="ac_btn"
                dense
              >
                <v-btn
                  v-for="opt in page_size_options"
                  :key="opt.value"
                  class="black--text"
                  style="background-color: #138166"
                  small
                  @click="on_page_size_change(opt.value)"
                >
                  {{ opt.label }}
                </v-btn>
              </v-btn-toggle>
            </div>
            <v-pagination
              v-if="page_size !== -1 && total_pages > 1"
              :value="page"
              :length="total_pages"
              :total-visible="7"
              @input="on_page_change"
              dark
              color="#138166"
            ></v-pagination>
            <p class="ml-4 mb-0 appbck">
              Showing {{ lst_letters.length }} of {{ total_count }}
            </p>
          </div>
        </div>

        <!-- officer_view -->
        <div
          id="officer_view"
          class="appbck mview"
          style="position: relative; top: 20px"
          v-if="isRecords == false"
        >
          <h2 class="ml-2">Officer View</h2>
          <h4 class="ml-3">Count: {{ lst_letters.length }}</h4>
          <p class="ml-3 mb-0 appbck">Search (names): &nbsp;</p>
          <div class="ml-3 mr-3 d-flex flex-column flex-sm-row align-stretch align-sm-center">
            <input
              ref="officer_search_input"
              type="text"
              maxlength="24"
             style="margin-bottom: 12px; padding: 8px; font-size: 16px; border: 1px solid #ccc; background-color: black; color: white; flex-grow: 1;"
              @keyup.enter="do_officer_search"
            />
            <div class="d-flex mt-2 mt-sm-0 ml-sm-2">
              <v-btn
                class="black--text flex-grow-1"
                style="background-color: #138166"
                @click="do_officer_search"
              >
                Search
              </v-btn>
              <v-btn
                class="ml-2 black--text flex-grow-1"
                style="background-color: #c8a84b"
                @click="do_officer_clear"
              >
                Clear
              </v-btn>
            </div>
          </div>
          <div class="ml-2 mb-3 pa-0 d-flex tggl-cont">
            <p class="appbck">Sort: &nbsp;</p>

            <v-btn-toggle
              v-model="toggle_exclusive"
              mandatory
              active-class="ac_btn"
              @change="toggle_sort"
              class=""
            >
              <v-btn
                class="black--text"
                elevation="2"
                style="background-color: #138166"
              >
                A-Z
              </v-btn>
              <v-btn
                class="black--text"
                elevation="2"
                style="background-color: #138166"
              >
                Date
              </v-btn>
            </v-btn-toggle>
          </div>

          <v-card
            style="width: 95%; margin: auto"
            class="mb-5 cntct_card"
            v-for="ltr in lst_letters"
            :key="ltr.letterId"
            elevation="2"
            dark
            outline
            ><v-card-title v-if="ltr.property_name != ''">
              <span class="labeltext--text">Property Name:&nbsp;</span>
              {{ ltr.property_name }}
            </v-card-title>
            <v-card-title v-if="ltr.property_name == ''">
              <span class="labeltext--text">Owner Name:&nbsp;</span>
              {{ ltr.owner_name }}
            </v-card-title>
            <v-card-subtitle
              >{{ ltr.address_line1 }}&nbsp;
              <span v-if="ltr.address_line2">{{ ltr.address_line2 }} </span>
              <span class="labeltext--text">City:&nbsp;</span>
              {{ ltr.city }}
              <!-- ,<span class="labeltext--text">State:&nbsp;</span>
              {{ ltr.state }},
              <span class="labeltext--text">Zip:&nbsp;</span>
              {{ ltr.zip }} -->
            </v-card-subtitle>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="4">
                  <div class="d-flex">
                    <span class="labeltext--text">Phone:&nbsp;</span
                    >{{ ltr.contact_phone }}
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="d-flex">
                    <span class="labeltext--text">Email:&nbsp;</span
                    >{{ ltr.contact_email }}
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="d-flex">
                    <span class="labeltext--text"
                      >Effective&nbsp;Date:&nbsp;</span
                    >{{ ltr.effective_date }}
                  </div>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="d-flex">
                    <span class="labeltext--text">Sign Count:&nbsp;</span
                    >{{ ltr.phys_sign }}
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex">
                    <span class="labeltext--text">Last Sign Date:&nbsp;</span
                    >{{ ltr.last_date_phys_sign }}
                  </div>
                </v-col>
              </v-row>
              <v-expansion-panels dark class="mt-2">
                <v-expansion-panel>
                  <v-expansion-panel-header style="border: 1px solid white">
                    More Contacts
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Alt Name 1:&nbsp;</span
                          >{{ ltr.alt_contact_name1 }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Alt Phone 1:&nbsp;</span
                          >{{ ltr.alt_contact_phone1 }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Alt Name 2:&nbsp;</span
                          >{{ ltr.alt_contact_name2 }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Alt Phone 2:&nbsp;</span
                          >{{ ltr.alt_contact_phone2 }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense class="mt-2">
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Address:&nbsp;</span
                          >{{ ltr.address_line1 }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <span class="labeltext--text">Suite:&nbsp;</span
                          >{{ ltr.address_line2 }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense class="">
                      <v-col cols="12" md="4">
                        <div class="d-flex">
                          <span class="labeltext--text">City:&nbsp;</span
                          >{{ ltr.city }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="d-flex">
                          <span class="labeltext--text">State:&nbsp;</span
                          >{{ ltr.state }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="d-flex">
                          <span class="labeltext--text">Zip:&nbsp;</span
                          >{{ ltr.zip }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
          <p v-if="show_no_contacts">No contacts match search.</p>
        </div>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .remsign {
    margin-top: 5px;
  }
  .select-wrapper {
    position: relative;
    display: inline-block;
    width: 238px;
  }

  .select-wrapper select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: rgb(0, 0, 0);
    padding: 10px;
    border: 1px solid #ccc;
    width: 238px;
  }
  /* Custom arrow */
  .select-wrapper::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 10px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #ffffff;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .select-wrapper33 {
    position: relative;
    display: inline-block;
    width: 238px;
  }
  .select-wrapper33 select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: rgb(0, 0, 0);
    padding: 10px;
    border: 1px solid #ccc;
    width: 238px;
  }
  /* Custom arrow */
  .select-wrapper33::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 10px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #ffffff;
    transform: translateY(-50%);
    pointer-events: none;
  }
  .theme--dark.v-input {
    color: white !important;
  }

  .white-clear-icon >>> .v-input__icon--clear button {
    color: white;
  }
  .ac_btn {
    background-color: #1fdeb0 !important;
    color: white !important;
  }
  #home-container {
    width: 100%;
    height: fit-content;
  }
  .mview {
    width: 95%;
    margin: auto;
  }

  .homemain {
    margin-top: 55px;
  }
  .alice {
    color: aliceblue;
  }

  .section1 h1 {
    text-shadow: 2px 2px 4px #000000;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .remsign {
    margin-top: 0;
    margin-left: 5px;
  }
  .select-wrapper {
    position: relative;
    display: inline-block;
    width: 337px;
  }

  .select-wrapper select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: rgb(0, 0, 0);
    padding: 10px;
    border: 1px solid #ccc;
    width: 337px;
  }
  /* Custom arrow */
  .select-wrapper::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 10px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #ffffff;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .select-wrapper33 {
    position: relative;
    display: inline-block;
    width: 223px;
  }
  .select-wrapper33 select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: rgb(0, 0, 0);
    padding: 10px;
    border: 1px solid #ccc;
    width: 223px;
  }
  /* Custom arrow */
  .select-wrapper33::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 10px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #ffffff;
    transform: translateY(-50%);
    pointer-events: none;
  }
  .section1 {
    justify-content: center;
    width: 100%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .section1 {
    justify-content: flex-start;
    width: 100%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
label {
  color: lightgrey;
  font-size: 12px;
  margin: 0;
  padding: 0;
}
</style>

<script>
/* eslint-disable */
import { fromStringWithSourceMap } from "source-list-map";
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";

export default {
  name: "Home",
  components: {
    auth,
  },
  mixins: [bus_common],
  data() {
    return {
      devrole: "off",
      states: [
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
      property_types: [
        "Residential",
        "Commercial",
        "Empty Lot",
        "Railroad Easement",
      ],
      valid: true,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      reqRules: [(v) => !!v || "Field is required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) =>
          (v && v.length <= 120) || "Name must be less than 120 characters",
      ],
      existing_letters: [
        "Renewal of an existing letter",
        "New Authorization Letter",
      ],
      edit_ltr: {},
      dialog: false,
      sort: "az",
      show_no_contacts: false,
      sterm: "",
      toggle_exclusive: 0,
      lst_letters: [],
      page: 1,
      page_size: 10,
      total_count: 0,
      total_pages: 1,
      page_size_options: [
        { value: 10, label: "10" },
        { value: 50, label: "50" },
        { value: -1, label: "All" },
      ],
      right: null,
      search: "",
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },
  computed: {
    daroles() {
      return this.$store.state.user.roles;
    },
    // isRecords() {
    //   if (this.devrole == "rec") {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // isOfficer() {
    //   if (this.devrole == "off") {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    isRecords() {
  
      if (this.$store.state.user.roles.indexOf("loit-rec") > -1) {
        return true;
      } else {
        return false;
      }
    },
    isOfficer() {
      if (this.$store.state.user.roles.indexOf("loit-off") > -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    tgl_role() {
      if (this.devrole == "off") {
        this.devrole = "rec";
      } else {
        this.devrole = "off";
      }
    },
    close_diag() {
      this.dialog = false;
    },

    delete_now(ltr) {
      let self = this;

      this.show_loader(true);
      let formIn = {};
      formIn.letterId = ltr.letterId;
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "delete_now";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getRecentLetters();
          this.swall_it("Delete Status", "Deleted.", "success", null, null);
          this.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    delete_promp(ltr) {
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting a record for property owner '" +
          ltr.owner_name +
          ",' do you wish to continue?",
        "question",
        function () {
          self.delete_now(ltr);
        },
        null,
        null,
        function () {}
      );
    },
    remvsign() {
      if (this.edit_ltr.phys_sign < 1) {
        this.swall_it(
          "Save Status",
          "Physical Sign count cannot be zero.",
          "warning",
          null,
          null
        );
        return true;
      }
      let self = this;

      this.show_loader(true);
      let formIn = {};
      formIn.letterId = this.edit_ltr.letterId;
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "remvsign";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getRecentLetters();
          self.edit_ltr.last_date_phys_sign = self.format_date_us(new Date());
          self.edit_ltr.phys_sign -= 1;
          this.show_loader(false);

          this.swall_it("Save Status", "Saved.", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    addsign() {
      let self = this;

      this.show_loader(true);
      let formIn = {};
      formIn.letterId = this.edit_ltr.letterId;
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.phys_sign = parseInt(this.edit_ltr.phys_sign);

      formIn.apiname = "addsign";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getRecentLetters();
          self.edit_ltr.last_date_phys_sign = self.format_date_us(new Date());

          this.show_loader(false);

          this.swall_it("Save Status", "Saved.", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    update_ltr() {
      if (this.$refs.form.validate() == false) {
        this.swall_it(
          "Save Status",
          "Some fields are not correct. Please address the red fields before continuing.",
          "warning",
          null,
          null
        );
        return true;
      }
      let self = this;

      this.show_loader(true);
      let formIn = {};
      formIn.ltr = this.mno(this.edit_ltr);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.ltr.today_date = this.format_date_sql(formIn.ltr.today_date);
      formIn.ltr.today_time = this.format_date_sql(formIn.ltr.today_time);
      formIn.ltr.effective_date = this.format_date_sql(
        formIn.ltr.effective_date
      );
      formIn.ltr.s_date = this.format_date_sql(formIn.ltr.s_date);
      formIn.ltr.s_CreateDate = this.format_date_sql(formIn.ltr.s_CreateDate);

      formIn.apiname = "update_ltr";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getRecentLetters();
          self.dialog = false;
          this.show_loader(false);

          this.swall_it("Save Status", "Saved.", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    edit(ltr) {
      this.edit_ltr = this.mno(ltr);
      this.edit_ltr.effective_date = this.format_date_sql(
        this.edit_ltr.effective_date
      );

      this.dialog = true;
    },
    toggle_sort() {
      if (this.toggle_exclusive == 1) {
        this.sort = "dt";
      } else {
        this.sort = "az";
      }
      this.page = 1;
      this.getRecentLetters();
    },
    filter() {
      if (this.sterm == "") {
        this.handleClear();
      }
      if (this.sterm.length >= 3) {
        this.show_no_contacts = false;
        let lst_contacts = document.querySelectorAll(".cntct_card");
        //hide all
        lst_contacts.forEach((cntct) => {
          cntct.style.display = "none";
        });
        //show matches
        let cnt = 0;

        lst_contacts.forEach((cntct) => {
          let srcstr = cntct.innerHTML.toString().toLowerCase();
          let term = this.sterm.toLowerCase();
          if (srcstr.indexOf(term) > -1) {
            cnt++;

            cntct.style.display = "block";
          }
        });
        if (cnt == 0) {
          this.show_no_contacts = true;
        }
      }
    },
    handleClear() {
      this.show_no_contacts = false;
      this.sterm = "";
      let lst_contacts = document.querySelectorAll(".cntct_card");
      lst_contacts.forEach((cntct) => {
        cntct.style.display = "block";
      });
    },
    do_officer_search() {
      // Plain HTML input — read value directly from the DOM via ref.
      // Push it into sterm, then delegate to the existing filter().
      const input = this.$refs.officer_search_input;
      this.sterm = (input && input.value) ? input.value : "";
      this.filter();
    },
    do_officer_clear() {
      // Clear the plain input's DOM value, then delegate to existing handleClear().
      const input = this.$refs.officer_search_input;
      if (input) input.value = "";
      this.handleClear();
    },
    message1() {
      alert("This button does nothing yet.");
    },

    message2() {
      alert("when clicked this ");
    },
    // get_next() {
    //   //add to lsit of stat items
    //   console.log("intesect");

    //   this.total_loaded += this.group_size;

    //   var self = this;

    //   var formIn = {};
    //   formIn.email = this.$store.state.user.email;
    //   formIn.token = this.$store.state.user.token;
    //   formIn.group_size = this.group_size;
    //   formIn.total_loaded = this.total_loaded;

    //   formIn.apiname = "get_recent_rpd_stats";
    //   var self = this;
    //   this.$store
    //     .dispatch("anyapi", formIn)
    //     .then((data) => {
    //       console.log("new stuff " + data.length);
    //       var stats_to_add = this.mno(data);
    //       for (let index = 0; index < stats_to_add.length; index++) {
    //         const stat = stats_to_add[index];
    //         stat.mil_time = self.frm_jsDate_toMilTime(stat.s_date);
    //         self.lst_letters.push(stat);
    //       }
    //     })
    //     .catch((msg) => {
    //       this.show_loader(false);
    //       this.swall_it("Error", msg, "error", null, null);
    //     });
    // },
    getRecentLetters() {
      var self = this;
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.page = this.page;
 formIn.page_size = this.isRecords ? this.page_size : -1;
     console.log(" formIn.page_size " +  formIn.page_size);
      formIn.sort = this.sort;
      formIn.search_term = this.sterm || "";

      formIn.apiname = "getRecentLetters";
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          // backend now returns { items, total_count, page, page_size, total_pages }
          self.total_count = data.total_count;
          self.total_pages = data.total_pages;
          self.page = data.page;
          self.lst_letters = self.mno(data.items);

          self.lst_letters.forEach((ltr) => {
            ltr.effective_date = self.format_date_us(ltr.effective_date);
            ltr.last_date_phys_sign = self.format_date_us(
              ltr.last_date_phys_sign
            );
            if (ltr.last_date_phys_sign == "01/01/1900") {
              ltr.last_date_phys_sign = "None";
            }
          });
          this.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    on_page_change(newPage) {
      this.page = newPage;
      this.getRecentLetters();
    },
    on_page_size_change(newSize) {
      this.page_size = newSize;
      this.page = 1; // reset to first page when size changes
      this.getRecentLetters();
    },
    submit_search() {
      this.page = 1; // new search always starts at page 1
      this.getRecentLetters();
    },
    clear_search() {
      this.sterm = "";
      this.page = 1;
      this.getRecentLetters();
    },
    init(self) {
      this.getRecentLetters(); // sort by name default
    },
  },
  created() {
    this.show_loader(true);
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>